var render, staticRenderFns
import script from "./CategoryServiceField.vue?vue&type=script&lang=js&"
export * from "./CategoryServiceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63d27498')) {
      api.createRecord('63d27498', component.options)
    } else {
      api.reload('63d27498', component.options)
    }
    
  }
}
component.options.__file = "resources/js/pages/orders/fields/CategoryServiceField.vue"
export default component.exports